/**
 * 集柜文件管理
 *
 * Author:   gsm(qq:2479186745)
 * History:
 * Date         Version Remarks
 * ============ ======= ======================================================
 * 2023/4/21      1.0     First version
 *
 * Copyright 2016, all rights reserved. Essa.cn
 * */

import React from 'react'
import PropTypes from "prop-types";
import Lang from "@/components/Lang/Lang";
import {Modal,Button} from 'antd';
import  utilExcelStrict from '@utils/utilExcelStrict';
import AuthBtn from "@components/HoverIcon/AuthBtn";
import UploadFile from '@/components/UploadFile/UploadFile'
import {postQueryUploadContainerFile,postDoUploadContainer} from "@/api/financeManagement";
import "./index.less";
import dayjs from "dayjs";

class FileManagement extends React.Component{
    constructor(props) {
        super(props);
        this.state = {
            visible:false,
            otherPubAttachList:[],
            returnFinishPubAttachList:[],
            returnPubAttachList:[],
            waybillPubAttachList:[],
        }
    }

    /**
     * 处理列表
     * @param listName
     * @return {[]}
     */
    handlePostList(listName,groupCode){
        let list = [];
        this.state[listName].forEach((item)=>{
            if(!item.isDelete){
                list.push({
                    groupCode:groupCode,
                    fileName:item.fileName,
                    fileExtend:item.fileExtend,
                    createBy:item.createBy,
                    createTime:item.createTime,
                    createUserName:item.createUserName,
                    fileId:item.fileId,
                    migOldId:item.migOldId,
                })
            }
        })
        return list;
    }

    onOk(){
        const modal =  Modal.confirm({
            title:Lang({id:'TiShi',default: "提示"}),
            content:Lang({id:'RuGuoYouSanCuWenJian',default: "如果有删除文件，确定后将无法撤销或恢复"}),
            okText:Lang({id:'QueDing',default: "确定"}),
            cancelText:Lang({id:'QuXiao',default: "取消"}),
            onOk:()=>{
                var postData = {
                    id:this.props.id,
                    otherPubAttachList:this.handlePostList('otherPubAttachList','CON_DOCUMENT_OTHER'),
                    returnFinishPubAttachList:this.handlePostList('returnFinishPubAttachList','CON_DOCUMENT_RETURN_FINISH'),
                    returnPubAttachList:this.handlePostList('returnPubAttachList','CON_DOCUMENT_RETURN'),
                    waybillPubAttachList:this.handlePostList('waybillPubAttachList','CON_DOCUMENT_WAYBILL')
                }
                postDoUploadContainer(postData).then((res)=>{
                    if(res.data.success&&res.data.valid){
                        modal.destroy();
                        this.changeVisible(false);
                    }
                })
            },
            onCancel:()=>{
                modal.destroy();
            }
        })

    }

    /**
     * 切换modal
     */
    changeVisible(visible){
        this.setState({
            visible:visible,
            otherPubAttachList:[],
            returnFinishPubAttachList:[],
            returnPubAttachList:[],
            waybillPubAttachList:[],
        },()=>{
            if(visible){
                this.getData();
            }
        })
    }

    /**
     * 获取文件图片
     * @param name
     * @return {string}
     */
    getFileImg(name){
        if(name){
            let nameArray = name.split(".");
            const suffix = nameArray[nameArray.length-1];
            if(['jpg','png'].indexOf(suffix)!=-1){
                return 'https://oss.essaone.com/287df57b-5ca2-4a34-8c11-0a5fb7dc4bbe.png';
            }else if(['xls','xlsx'].indexOf(suffix)!=-1){
                return 'https://oss.essaone.com/a10475c1-46fc-43dc-8a4c-af2b5071f53f.png';
            }else if(['pdf'].indexOf(suffix)!=-1){
                return 'https://oss.essaone.com/3399cd14-b870-40f6-b237-4241239dd2fc.png';
            }else{
                return 'https://oss.essaone.com/7e18926e-6381-42fa-a771-7c4f5e0e1cb9.png';
            }
        }else{
            return '';
        }

    }

    /**
     * 修改文件
     * @param name
     * @param fileList
     */
    changeFiles(name,fileList){
        this.setState({
            [name]:fileList.map((item)=>{
                let nameArray = (item.name).split(".");
                const suffix = nameArray[nameArray.length-1];
                item.fileExtend = suffix;
                return item;
            })
        })
    }

    /**
     * 是否删除
     * @param name
     * @param itemIndex
     * @param isDelete
     */
    changeDelete(name,itemIndex,isDelete=0){
        this.setState({
            [name]:this.state[name].map((item,index)=>{
                if(itemIndex==index){
                    item.isDelete = !isDelete;
                }
                return item;
            })
        })
    }

    /**
     * 获取数据
     */
    getData(){
        postQueryUploadContainerFile({
            id:this.props.id
        }).then((res)=>{
            let model = res.data.model||{};
            this.setState({
                otherPubAttachList:model.otherPubAttachList||[],
                returnFinishPubAttachList:model. returnFinishPubAttachList||[],
                returnPubAttachList:model.returnPubAttachList||[],
                waybillPubAttachList:model.waybillPubAttachList||[],
            })
        })
    }

    /**
     * 下载
     * @param item
     */
    openFile(item){
        window.open(item.fileUrl);
    }

    /**
     * 获取item
     * @param item
     * @param index
     * @param canOperable 是否可操作
     * @return {*}
     */
    getChildren(name,item,index,canOperable){
        return <li key={index}>
            <div className="align-self-center">
                <p className="flex-item">
                    <img src={this.getFileImg(item.fileName)} className="img align-self-center" alt=""/>
                    <span className={`font_14 ml_6 align-self-center ${item.isDelete?'util-del':''}`}
                            onClick={this.openFile.bind(this,item)}>
                        {item.fileName}
                    </span>
                </p>
                {
                    (item.createUserName||item.createTime)?
                        <p className="font_12 color045 mt_4">{item.createUserName||'-'} {item.createTime?dayjs(item.createTime).format('YYYY-MM-DD HH:mm:ss'):null}</p>
                        :
                        null
                }
            </div>
            {
                canOperable?
                    <div className="btn-wrap align-self-center">
                        <i className={`${item.isDelete?'ri-arrow-go-back-line':'ri-delete-bin-6-line'}`}
                           onClick={this.changeDelete.bind(this,name,index,item.isDelete)}></i>
                    </div>
                    :
                    null
            }

        </li>
    }

    render(){
            const {children} = this.props;
        let {
            otherPubAttachList,
            returnFinishPubAttachList,
            returnPubAttachList,
            waybillPubAttachList
        } = this.state;
        const uploadSetting = {
            replace:true,
            accept:'zip,pdf,jpg,png,xls,xlsx',
            showUploadList:false,
        }
        return (
            <>
                {children?<span onClick={()=>this.changeVisible(true)}>{children}</span>:<AuthBtn icon={"ri-folder-zip-line"}
                                                                                                  tips = {Lang({id:"JiGuiWenJianGuanLi",default:"集柜文件管理"})}
                               onClick={()=>this.changeVisible(true)}/>}

                {/*<span onClick={this.changeVisible.bind(this,true)}>{this.props.children}</span>*/}
                <Modal open={this.state.visible}
                       okText={Lang({id:'QueDing',default: "确定"})}
                       cancelText={Lang({id:'QuXiao',default: "取消"})}
                       onOk={this.onOk.bind(this)}
                       onCancel={this.changeVisible.bind(this,false)}
                       title={Lang({id:'JiGuiWenJianGuanLi',default: "集柜文件管理"})}>
                    <div className="file-management-wrap">
                        {
                            this.state.visible?
                                <div className="file-management-main">
                                    <p>{__getServerLanguage('ZhiCiWenJianGeShi','zip、pdf、jpg、png、xls、xlsx','500')}</p>
                                    <div className="item">
                                        <div className="tits">{Lang({id:'HuanGuiWenJian',default: "还柜文件"})}</div>
                                        <ul>
                                            {
                                                (returnPubAttachList||[]).map((item,itemIndex)=>{
                                                    return this.getChildren('returnPubAttachList',item,itemIndex,1);
                                                })
                                            }
                                        </ul>
                                        <UploadFile {...uploadSetting} initValue={returnPubAttachList}
                                                    onChange={(fileList)=>{
                                                        this.changeFiles('returnPubAttachList',fileList);
                                                    }}>
                                            <Button>{Lang({id:'ShangChuanWenJian',default: "上传文件"})}</Button>
                                        </UploadFile>
                                    </div>
                                    <div className="item">
                                        <div className="tits">{Lang({id:'YiHuanGui',default: "已还柜"})}</div>
                                        <ul>
                                            {
                                                (returnFinishPubAttachList||[]).map((item,itemIndex)=>{
                                                    return this.getChildren('returnFinishPubAttachList',item,itemIndex,1);
                                                })
                                            }
                                        </ul>
                                        <UploadFile {...uploadSetting} initValue={returnFinishPubAttachList}
                                                    onChange={(fileList)=>{
                                                        this.changeFiles('returnFinishPubAttachList',fileList);
                                                    }}>
                                            <Button>{Lang({id:'ShangChuanWenJian',default: "上传文件"})}</Button>
                                        </UploadFile>
                                    </div>
                                    <div className="item">
                                        <div className="tits">{Lang({id:'YunDanWenJian',default: "运单文件"})}</div>
                                        <ul>
                                            {
                                                (waybillPubAttachList||[]).map((item,itemIndex)=>{
                                                    return this.getChildren('waybillPubAttachList',item,itemIndex,1);
                                                })
                                            }
                                        </ul>
                                        <UploadFile {...uploadSetting} initValue={waybillPubAttachList}
                                                    onChange={(fileList)=>{
                                                        this.changeFiles('waybillPubAttachList',fileList);
                                                    }}>
                                            <Button>{Lang({id:'ShangChuanWenJian',default: "上传文件"})}</Button>
                                        </UploadFile>
                                    </div>
                                    <div className="item">
                                        <div className="tits">{Lang({id:'QiTaWenJian',default: "其他文件"})}</div>
                                        <ul>
                                            {
                                                (otherPubAttachList||[]).map((item,itemIndex)=>{
                                                    return this.getChildren('otherPubAttachList',item,itemIndex,1);
                                                })
                                            }
                                        </ul>
                                        <UploadFile {...uploadSetting} initValue={otherPubAttachList}
                                                    onChange={(fileList)=>{
                                                        this.changeFiles('otherPubAttachList',fileList);
                                                    }}>
                                            <Button>{Lang({id:'ShangChuanWenJian',default: "上传文件"})}</Button>
                                        </UploadFile>
                                    </div>
                                </div>
                                :
                                null
                        }
                    </div>
                </Modal>
            </>
        )
    }
}

FileManagement.defaultProps = {
}

FileManagement.propTypes = {

}
export default FileManagement;
